import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { JobAutomationFormComponent } from '@employer/app/components/jobs-automation/job-automation-form.component'
import { CustomerModule as SDKCustomerModule } from '@engineering11/customer-web'
import { FilesModule } from '@engineering11/files-web'
import { E11LoaderDotsModule } from '@engineering11/ui-lib/e11-loader-dots'
import { CustomerClientSubscriptionsComponent } from '@engineering11/payment-web'
import { RegistrationModule } from '@engineering11/registration-web'
import { WebUtilityModule } from '@engineering11/web-utilities'
import { LetDirective } from '@ngrx/component'
import { EmployerCustomerConfigProvider, EmployerCustomerPartitionConfigProvider } from '../../config/customer.config'
import { UiComponentLibraryModule } from '../_component-library/component-library.module'
import { SharedModule } from '../_shared/shared.module'
import { InterviewQuestionLibraryModule } from '../interview-question-library/interview-question-library.module'
import { RequiredContactDetailsFormComponent } from '../jobs/components/job-forms/job-form-options/required-contact-details-form.component'
import { CompanyLogoUploadModalComponent } from './components/company-logo-upload-modal/company-logo-upload-modal.component'
import { CustomerManageHeaderComponent } from './components/customer-manage-header.component'
import { CustomerManageIndustryComponent } from './components/manage-industry/manage-industry.component'
import { CustomerManageProfilePicComponent } from './components/manage-profile-pic/manage-profile-pic.component'
import { CustomerManageSettingsComponent } from './components/manage-settings/manage-settings.component'
import { CustomerMenuLeftComponent } from './components/menu-left/menu-left.component'
import { CustomerModalProfilePicComponent } from './components/modal-profile-pic/modal-profile-pic.component'
import { CustomerRoutingModule } from './customer.routing'
import { CareersPageHeroComponent } from './views/careers-page-hero/careers-page-hero.component'
import { CustomerComplianceComponent } from './views/compliance.component'
import { CustomerDepartmentsComponent } from './views/departments.component'
import { CustomerHomeComponent } from './views/home/customer-home.component'
import { RequiredContactDetailsComponent } from './views/job-and-application-settings/required-contact-details.component'
import { JobApplicationSettingsComponent } from './views/job-application-settings/job-application-settings.component'
import { JobNotificationConfigFormComponent } from './views/job-application-settings/job-notification-config-form.component'
import { AutoQuestionFormComponent } from './views/jobs-post-automation-company-settings/auto-question.component'
import { JobsPostAutomationCompanySettingsComponent } from './views/jobs-post-automation-company-settings/jobs-post-automation-company-settings.component'
import { CustomerLocationsComponent } from './views/locations.component'
import { EmployerFooterLogoComponent } from './views/manage-company-logo/company-footer-logo/emloyer-footer-logo.component'
import { ManageCompanyLogoComponent } from './views/manage-company-logo/manage-company-logo.component'
import { CareersPageLinkComponent } from './views/manage-employer-settings/careers-page-link-section.component'
import { EmployerSettingComponent } from './views/manage-employer-settings/employer-setting.component'
import { ManageEmployerSettingsComponent } from './views/manage-employer-settings/manage-employer.component'
import { CustomerSocialMediaComponent } from './views/social-media/social-media.component'

@NgModule({
  declarations: [
    CustomerHomeComponent,
    CustomerMenuLeftComponent,
    CustomerManageProfilePicComponent,
    CustomerManageSettingsComponent,
    ManageEmployerSettingsComponent,
    CustomerManageIndustryComponent,
    CustomerDepartmentsComponent,
    ManageCompanyLogoComponent,
    CustomerModalProfilePicComponent,
    CareersPageHeroComponent,

    CompanyLogoUploadModalComponent,
    CustomerSocialMediaComponent,
    CustomerManageHeaderComponent,
    CustomerLocationsComponent,
    CustomerComplianceComponent,
    CareersPageLinkComponent,
    EmployerSettingComponent,
    JobsPostAutomationCompanySettingsComponent,
    JobApplicationSettingsComponent,
    RequiredContactDetailsComponent,
    EmployerFooterLogoComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,

    SDKCustomerModule.forRoot({
      configProvider: EmployerCustomerConfigProvider,
      partitionConfigProvider: EmployerCustomerPartitionConfigProvider,
      dynamicCustomersTabComponents: [
        {
          label: 'Subscriptions',
          id: 'subscriptions',
          component: CustomerClientSubscriptionsComponent,
        },
      ],
    }),
    CustomerRoutingModule,
    UiComponentLibraryModule,
    FormsModule,
    InterviewQuestionLibraryModule,
    ReactiveFormsModule,
    RegistrationModule,
    WebUtilityModule,
    LetDirective,
    FilesModule,
    JobAutomationFormComponent,
    AutoQuestionFormComponent,
    RequiredContactDetailsFormComponent,
    JobNotificationConfigFormComponent,
    E11LoaderDotsModule,
  ],
  exports: [],
  providers: [],
})
export class CustomerModule {}
